const step = 10;
export default function onClickFunctionKeys(functionKey, pageNumbers, currentPage) {
  if (functionKey === 0) { // 처음
      return 1;
  }
  if (functionKey === 1) { // 이전
      const nextPage = Math.ceil(currentPage / step) * step - step;
      return currentPage > 10 ? nextPage : 1;
  }
  if (functionKey === 2) { // 다음
      const nextPage = Math.ceil(currentPage / step) * step + 1;
      return nextPage <= pageNumbers[pageNumbers.length - 1] ? nextPage : pageNumbers[pageNumbers.length - 1];
  }
  if (functionKey === 3) { // 마지막
      return pageNumbers[pageNumbers.length - 1];
  }
};